// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1PRbT","error-label":"LoginForm_error-label__1QAry"};